<app-modal class="more-actions-modal" [(visible)]="visible" (onCancel)="cancel()" header="WARNING">
    <p>Bulk actions have a limit of 50,000 chases.Your action will apply only to first 50,000 chases in your list.Do you wish to continue ? </p>
  
    <footer>
      <app-button class="header-button" text="Continue" (onClick)="onContinue()" ></app-button>
    </footer>
  </app-modal>
  
  
  